import axios from "axios";
import { APIBaseUrl } from "./apiInterceptor";
const BASE_URL = 'http://localhost:5000'
export const findSectionData = async (name) => {
    return await axios.get(`${BASE_URL}/api/data?sectionName=${name}`)
        .then((response) => response.data)
        .catch((err) => err?.response?.data || err);
};
export const findCategories = async (name) => {
    return await axios.get(`${BASE_URL}/api/categories`)
        .then((response) => response.data)
        .catch((err) => err?.response?.data || err);
};

export const findEntityData = async (query) => {
    return await APIBaseUrl.get(`/entity/${query}/get_by_query`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};

export const findGalleryCategories = async (query) => {
    return await APIBaseUrl.get(`/entity/sss_get_active_categories/get_by_query`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};

export const findImage = async (id) => {
    return await APIBaseUrl.get(`/entity/file_storage/get_by_id?_id=${id}`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};

export const findAllImage = async (id) => {
    return await APIBaseUrl.get(`/entity/find_file_url_from_id/get_by_query?objectIds=${id}`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};

export const findSpecificServicePage = async (name) => {
    return await APIBaseUrl.get(`/entity/sss_specific_service_data/get_by_query?servicename=${name}`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};

export const findAllServicePage = async (name) => {
    return await APIBaseUrl.get(`/entity/sss_get_all_services/get_by_query`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};
export const findBlogById = async (id) => {
    return await APIBaseUrl.get(`/entity/sss_blogs/get_by_id?_id=${id}`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};

export const findActiveBlogs = async () => {
    return await APIBaseUrl.get(`/entity/sss_blogs/get_by_query?isActive=true`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};
export const findBlogBySlug = async (slug) => {
    return await APIBaseUrl.get(`/entity/sss_specific_blogs/get_by_query?slug=${slug}`)
        .then(response => response.data)
        .catch(err => err?.response?.data || err);
};